import React, { useRef, useEffect } from "react";
import { MenuItem, TextField, InputAdornment } from "@mui/material";
import { Search } from "@mui/icons-material";
import { searchMenuItemStyles, searchTextFieldStyles } from "../styles/MultiSelectSearch.styles";

interface SingleSelectSearchProps {
	placeholder?: string;
	searchTerm: string;
	onSearchChange: (value: string) => void;
}

export const SingleSelectSearch: React.FC<SingleSelectSearchProps> = ({
	placeholder = "Search...",
	searchTerm,
	onSearchChange,
}) => {
	const inputRef = useRef<HTMLInputElement>(null);

	// Auto focus the input when mounted
	useEffect(() => {
		const timer = setTimeout(() => {
			inputRef.current?.focus();
		}, 100);
		return () => clearTimeout(timer);
	}, []);

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		e.stopPropagation();
		onSearchChange(e.target.value);
	};

	const handleClick = (e: React.MouseEvent) => {
		e.stopPropagation();
		e.preventDefault();
	};

	const handleKeyDown = (e: React.KeyboardEvent) => {
		// Prevent default menu behavior for all keys except Enter and Escape
		if (e.key !== "Enter" && e.key !== "Escape") {
			e.stopPropagation();
		}
	};

	const handleMouseDown = (e: React.MouseEvent) => {
		// Prevent the menu from closing when clicking in the search input
		e.stopPropagation();
	};

	return (
		<MenuItem 
			disableRipple 
			sx={searchMenuItemStyles}
			onMouseDown={handleMouseDown}
			onClick={handleClick}
			value="" // Add empty value to prevent MUI errors
		>
			<TextField
				inputRef={inputRef}
				size="small"
				margin="none"
				placeholder={placeholder}
				variant="outlined"
				value={searchTerm}
				onChange={handleChange}
				fullWidth
				InputProps={{
					startAdornment: (
						<InputAdornment position="start">
							<Search sx={{ fontSize: "20px", color: "#9CA3AF" }} />
						</InputAdornment>
					),
				}}
				sx={searchTextFieldStyles}
				onClick={handleClick}
				onKeyDown={handleKeyDown}
				onMouseDown={handleMouseDown}
				autoComplete="off"
				autoFocus
			/>
		</MenuItem>
	);
};
